import { Box, Button, Container, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation();
    return (
        <>
            <Box sx={{py: 5, background: 'linear-gradient(50deg, rgba(235,64,129,1) 0%, rgba(177,30,28,1) 100%)', color: '#fff', fontWeight: '200'}}>
                <Container>
                    <Grid
                        container
                        alignItems="top"
                        spacing={4}
                    >
                        <Grid xs={6} md={3} item>
                            {t('footer.leftContent')}
                        </Grid>
                        <Grid xs={6} md={3} item>

                            <Box sx={{textDecoration: 'underline', fontWeight: '600', mb: 3}}>
                                {t('footer.needHelp')}
                            </Box>
                            <Box>
                                {t('footer.callCenter')}
                            </Box>
                            <Box>
                                {t('footer.mail')}
                            </Box>

                        </Grid>
                        <Grid xs={6} md={3} item>

                            <Box sx={{textDecoration: 'underline', fontWeight: '600', mb: 3}}>
                                {t('footer.company')}
                            </Box>
                            <Link to="/about-us" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    {t('footer.aboutUs')}
                                </Box>
                            </Link>
                            <Link to="/rewards" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    {t('footer.rewards')}
                                </Box>
                            </Link>
                            <Link to="/work-with-us" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    {t('footer.workWithUs')}
                                </Box>
                            </Link>
                            <Link to="/meet-the-team" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    {t('footer.meetTheTeam')}
                                </Box>
                            </Link>

                        </Grid>
                        <Grid xs={6} md={3} item>

                            <Box sx={{textDecoration: 'underline', fontWeight: '600', mb: 3}}>
                                {t('footer.support')}
                            </Box>
                            <Link to="/legal" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    {t('footer.legal')}
                                </Box>
                            </Link>
                            <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    {t('footer.contact')}
                                </Box>
                            </Link>
                            <Link to="/privacy-policy" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    {t('footer.privacyPolicy')}
                                </Box>
                            </Link>

                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
}

export default Footer;
